export const PRODUCTION_PLANTS_RESET_STATE = 'PRODUCTION_PLANTS_RESET_STATE';
export const PRODUCTION_PLANTS_CURRENT_ITEM = 'PRODUCTION_PLANTS_CURRENT_ITEM';

export const PRODUCTION_PLANTS_REQUEST_LOADING = 'PRODUCTION_PLANTS_REQUEST_LOADING';
export const PRODUCTION_PLANTS_REQUEST_SUCCESS = 'PRODUCTION_PLANTS_REQUEST_SUCCESS';
export const PRODUCTION_PLANTS_REQUEST_FAILED = 'PRODUCTION_PLANTS_REQUEST_FAILED';

export const PRODUCTION_PLANTS_CURRENT_ACTION = 'PRODUCTION_PLANTS_CURRENT_ACTION';
export const PRODUCTION_PLANTS_RESET_ACTION = 'PRODUCTION_PLANTS_RESET_ACTION';